// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bordered[data-v-ba54234e] {\n    border: 1px solid rgba(149, 155, 164, 0.25);\n    border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
